import { Calendar, Gift, TrendingUp, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const steps = [
  {
    number: 1,
    icon: Calendar,
    title: "Un moment de vie arrive",
    subtitle: "Anniversaire, Noël, diplôme...",
    description: "Créez une cagnotte-moment en 2 min : choisissez l'événement, invitez les proches",
    details: ["Événement + date", "Liste de proches", "Message d'invitation personnalisé"],
  },
  {
    number: 2,
    icon: Gift,
    title: "Les proches racontent ET contribuent",
    subtitle: "Photos, messages, vidéos + argent",
    description: "Chaque proche peut envoyer une photo, un message vidéo, un souvenir OU contribuer financièrement",
    details: ["Messages d'amour et vidéos", "Photos et souvenirs partagés", "Contributions financières libres"],
  },
  {
    number: 3,
    icon: TrendingUp,
    title: "L'histoire s'écrit, le capital grandit",
    subtitle: "Double croissance : émotionnelle + financière",
    description: "L'album-souvenir devient un journal de vie. En parallèle, l'argent est investi et croît automatiquement",
    details: ["Capsule temporelle émotionnelle", "Investissement diversifié automatique", "Double héritage : souvenirs + capital"],
  },
];

const NewHowItWorksSection = () => {
  return (
    <section id="how-it-works" className="section-padding bg-gradient-to-b from-tenderness-light to-white">
      <div className="container mx-auto">
        <div className="text-center mb-16">
          <div className="inline-block bg-legatia-green/20 text-legatia-green rounded-full px-6 py-2 mb-4">
            <span className="text-sm font-semibold">Un compte Legatia → Des cagnottes-moment → Un capital à 18 ans</span>
          </div>
          <h2 className="section-title">Du moment vécu au capital construit</h2>
          <p className="subtitle-hero max-w-3xl mx-auto">
            Comment chaque cagnotte-moment devient à la fois un souvenir immortalisé ET alimente son capital
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-12 mb-12">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="group relative">
                <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all border border-tenderness-light h-full">
                  <div className="relative mb-6">
                    <div className="w-20 h-20 mx-auto rounded-full bg-legatia-green flex items-center justify-center shadow-xl group-hover:scale-110 transition-transform">
                      <Icon className="h-10 w-10 text-white" />
                    </div>
                    <div className="absolute -top-2 -right-2 w-10 h-10 bg-legatia-green/20 text-legatia-green rounded-full flex items-center justify-center shadow-lg font-bold text-xl">
                      {step.number}
                    </div>
                  </div>

                  <div className="text-center mb-4">
                    <h3 className="text-2xl font-bold mb-2">{step.title}</h3>
                    <p className="text-sm text-primary font-medium">{step.subtitle}</p>
                  </div>

                  <p className="text-muted-foreground mb-6 leading-relaxed text-center">{step.description}</p>

                  <ul className="space-y-2 mt-6">
                    {step.details.map((detail, idx) => (
                      <li key={idx} className="flex items-start gap-2 text-sm">
                        <span className="w-1.5 h-1.5 rounded-full bg-primary mt-1.5 flex-shrink-0" />
                        <span>{detail}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                    <ArrowRight className="h-8 w-8 text-primary" />
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="text-center bg-gradient-to-r from-tenderness-light/50 via-white to-tenderness-light/50 rounded-2xl p-8">
          <p className="text-lg font-medium mb-4">
            Résultat : <span className="text-primary font-bold">Chaque moment devient double héritage</span>
          </p>
          <p className="text-muted-foreground mb-6 max-w-2xl mx-auto">
            18 ans de souvenirs immortalisés dans son album de vie + Un capital pour réaliser ses rêves
          </p>
          <Button
            className="bg-legatia-green hover:bg-legatia-green/90 text-white font-semibold text-lg px-10 py-6 rounded-full shadow-xl transform hover:scale-105 transition-all"
            onClick={() => window.location.href = "https://calendly.com/legatia/15min"}
          >
            Construire son avenir
          </Button>
        </div>
      </div>
    </section>
  );
};

export default NewHowItWorksSection;
